export default "__VITE_ASSET__K9UB2k4a__"